// extracted by mini-css-extract-plugin
export default {"fp_container":"Spiner_fp_container__n05ai","fp_loader":"Spiner_fp_loader__VjjHt"};